module.exports = __webpack_public_path__ + "img/wccdbanner.ad2fd8a9.jpg";